<div class="w-full h-full">
  <!-- New code start-->

  <div class="h-full w-full flex lg:flex-row gap-3">
    @if (isPlantEmptyUser) {
    <div class="flex flex-col flex-grow justify-start items-start bg-[#1d232b] rounded-lg m-5">
      <div class="flex flex-col items-center w-full h-full">
        <div class="w-full flex flex-col flex-grow justify-evenly items-center mb-10">
          <div>
            <div class="flex flex-col space-x-2 my-4 justify-center items-center gap-y-5">
              <img src="../../../../../assets/svg/add-plant-onboard.svg" class="max-w-72 sm:w-40 md:w-52 lg:w-64"
                alt="icon" />
              <span class="text-white label-xxl text-center">Elevate your energy<br />
                monitoring experience
              </span>

              <div
                class="flex-row hidden justify-center items-center rounded-xl bg-dark-accent-secondary px-4 py-[10px] text-white cursor-default"
                (appClickableDirective)="addNewPlantPopup()">
                <span class="text-xs p-0">{{
                  "Add New Plant" | translate
                  }}</span>
                <app-chevron-right-icon class="ml-2 text-xs" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } @else if (isPlantDeactivated) {
    <div class="flex   flex-col h-full w-full sm:px-8 sm:py-6 lg:px-8 lg:py-8 justify-start items-start bg-[#1d232b]">
      <div class="flex items-center w-full justify-between">
        <div class="flex flex-col justify-between items-start text-lg">
          <div class="flex items-center h-[1.4375rem]">
            <span class="text-xl text-[#EFEDEF] leading-[100%] tracking-wide font-medium">{{ selectedPlant?.plantName
              }}</span>
            @if (!isDeviceOffline) {
            <img src="../../../../../assets/svg/online.svg" alt="Online" class="h-2.5 w-[0.6344rem] ml-2.5" />
            @if (statData && statData.stats && statData.stats.wifi_signal_strength) {
            <img [src]="
                      '../../../../../assets/svg/' +
                      getStrengthImage(statData.stats.wifi_signal_strength) +
                      '.svg'
                    " class="w-3 h-3 ml-2" alt="strength" />
            }
            } @else {
            <div class="flex items-center">
              <div>
                <img src="../../../../../assets/svg/offline.svg" alt="Offline world"
                  class="h-2.5 w-[0.6344rem] ml-2.5" />
              </div>
              <div>
                <app-wifi-icon class="w-3 h-3 ml-2 text-[#E6E4E4]" />
              </div>
            </div>
            }
          </div>
          @if (statData) {
          <div class="flex sm:flex-col md:flex-row md:items-center h-fit mt-0.5">
            <div>
              <span class="text-base text-[#EFEDEF] font-normal">{{
                statData.deviceId
                }}</span>
            </div>

            <div>
              <span class="text-xs leading-[100%] text-[#AEAEAE] md:ml-4 md:-mt-2 font-normal text-[11px]">
                Last Updated:
                {{
                statData.stats!.last_updated_timestamp
                ? (statData.stats!.last_updated_timestamp * 1000
                | date: "dd/MM/yyyy hh:mm:ss a")
                : "NA"
                }}
              </span>
            </div>
          </div>
          }
        </div>
        <div class="flex">
          <!--plant info -->
          <div
            class="dark:bg-none py-2.5 px-3 h-9 rounded-[32px] border-[0.5px] border-solid border-gray-300 flex items-center gap-2.5 cursor-pointer"
            (appClickableDirective)="navigateToPlantDetail()">
            <span class="text-[#EBEAEB]">
              {{ "plant_info" | translate }}</span>
            <img src="../../../../../assets/svg/arrow.svg" alt="arrow" />
          </div>
          <!--notification button -->
          <div
            class="relative py-2.5 px-3 h-9 ml-2.5 rounded-[32px] border-solid border-[0.5px] border-gray-300 flex items-center justify-center gap-2.5 cursor-pointer"
            (appClickableDirective)="statData ? toggleNotificationDropdown() : null" onClickOutside
            (onClickOutside)="clickOutside('NOTIFICATION')">
            <div>
              <span class="text-[#EBEAEB]">
                {{ "notifications" | translate }}
              </span>
            </div>
            <div class="relative">
              <img src="../../../../../assets/svg/notification-hut.svg" alt="arrow" class="w-[16.05px] h-[16.03px]" />
              @if (
              statData && notificationList && notificationList.length > 0
              ) {
              <div class="absolute bg-white flex flex-col justify-center items-center rounded-full" [ngClass]="
                      notificationList.length < 10
                        ? 'w-3 h-3 top-[-2px] -right-1'
                        : 'h-[18px] w-[18px] top-[-6px] -right-2'
                    ">
                <span class="text-black text-[8px] m-0">{{
                  notificationList.length < 10 ? notificationList.length : "10+" }}</span>
              </div>
              }
            </div>
            @if(notificationDropdownVisible){
            <div class="absolute min-w-72 z-20 top-8 end-0 shadow-lg">
              <!-- Dropdown content -->
              <div class="flex flex-col mt-2 rounded-lg bg-slateGrey shadow-2xl">
                <div class="flex flex-row justify-start items-start space-x-2 ms-2 px-2 py-4">
                  <img src="../../../../../assets/svg/cus_notification.svg" alt="Notification" />
                  <span class="ps-4"> Notifications </span>
                </div>
                <div class="max-h-96 overflow-y-auto max-auto-scroll">
                  @for (item of notificationList; track $index) {
                  <div
                    class="flex flex-row justify-start items-start hover:bg-[#E2F1FC] hover:bg-opacity-10 hover: rounded-md py-2 px-2"
                    (appClickableDirective)="$event.stopPropagation()">
                    @if (item.data.alertName == "Info Alert") {
                    <img src="../../../../../assets/svg/notification_info.svg" alt="arrow" class="w-8 h-8" />
                    } @else if (
                    item.data.alertName != "Info Alert" &&
                    item.data.blocking == false
                    ) {
                    <img src="../../../../../assets/svg/notification_warning.svg" alt="arrow" class="w-8 h-8" />
                    } @else if (
                    item.data.alertName != "Info Alert" &&
                    item.data.blocking == true
                    ) {
                    <img src="../../../../../assets/svg/notification_alert.svg" alt="arrow" class="w-8 h-8" />
                    }

                    <div class="flex flex-col leading-4 ms-4">
                      <span class="text-xs">{{ item.data.title }}</span>
                      <span class="text-[10px] opacity-50">{{
                        item.data.body
                        }}</span>
                      <span class="text-[10px] opacity-50">{{
                        item.notificationDate
                        }}</span>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>}
            <!--Dropdown content end here-->
          </div>
        </div>
      </div>

      <div
        class="flex flex-col items-center flex-grow w-full rounded-[20px] bg-[#252A30] p-5 justify-center sm:mt-2.5 md:mt-2">
        <div class="flex flex-col justify-center items-center">
          <div class="flex w-fit h-fit flex-col justify-center items-center">
            <span class="text-white text-wrap text-[1.905rem] font-normal leading-[44.06px]">{{ selectedPlant?.plantName
              }} is deactivated.</span>
          </div>
          <div class="w-fit mt-8">
            <span class="text-white font-normal text-[1.397rem] leading-[100%] opacity-[50%]">To get the real time
              monitoring of the plant.</span>
          </div>
          <div
            class="flex flex-row justify-center mt- items-center rounded-[37.92px] bg-[#0051BA] px-4 py-[0.625rem] text-white w-[10.229rem] h-[3.159rem]"
            (appClickableDirective)="activatePlant()">
            <span class="font-medium text-[17.69px]">{{
              "activate_now" | translate
              }}</span>
          </div>
        </div>
      </div>
    </div>
    } @else if(!showNoDataScreen && statData) {
    <!--Template for GTI 
      -->
    @if(statData.inverterType == inverterType.ThinkPower ||
    statData.inverterType == inverterType.GTI || statData.inverterType==inverterType.THINKPOWERHESM)
    {
    <div
      class="w-full flex gap-3 flex-col main-template h-fit flex-grow sm:px-8 sm:py-6 lg:px-8 lg:py-8 sm:gap-3 lg:gap-0 md:gap-3 overflow-auto">

      <div class="flex sm:flex-col gap-3 lg:flex-row">
        <div
          class="sm:w-full lg:w-[32%] xl:w-[30%] sm:order-2 lg:order-1 py-5 pl-6 pr-7 items-stretch lg:h-unset rounded-[1.25rem] bg-[#252A30] sm:h-[68px]"
          [ngClass]="{ increaseBoxSize: increaseInfoBoxSize }">
          <div class="flex items-center justify-between sm:h-full lg:h-fit w-full leading-full"
            (appClickableDirective)="increaseSize()" [ngClass]="{ changeLineHeight: changeLineHeight }">
            <div>
              <span class="font-roboto font-normal tracking-[2%] w-[25px] text-left sm:text-base md:text-lg text-white">
                {{ "general_info" | translate }}
              </span>
            </div>
            <div class="sm:block lg:hidden" [ngClass]="{ changeRotation: changeRotation }">
              <img src="../../../../../assets/svg/opener-icon.svg" alt="Opener" />
            </div>
          </div>
          <div class="w-full h-full flex flex-col sm:hidden lg:flex" [ngClass]="{ showGeneralInfo: showGeneralInfo }">
            <div>
              <!-- General info card one -->
              <div class="flex lg:justify-between mt-3 sm:w-fit lg:w-full">
                <div class="flex flex-col w-fit">
                  <div class="flex justify-between flex-col w-fit">
                    <div>
                      <span
                        class="font-roboto sm:text-sm ml-0 font-normal md:text-base tracking-normal text-left opacity-50 text-white">
                        {{ "model_name" | translate }}
                      </span>
                    </div>
                    <div class="mt-1 lg:mt-1.5 xl:mt-2 w-fit h-fit">
                      <span class="font-roboto sm:text-sm font-normal tracking-normal text-wrap text-white">
                        {{ statData.inverterModel }}
                      </span>
                    </div>
                  </div>

                </div>
                <div class="flex lg:justify-end sm:ml-12 md:ml-14 lg:ml-unset">
                  <img [src]="
                        plantData?.plantPhoto ||
                        '../../../../../assets/images/plantdefault.svg'
                      " alt="preview"
                    class="sm:w-[10.31rem] sm:h-[5.50rem] md:h-[5.5031rem] lg:h-[4.77rem] lg:w-[6.86rem] rounded-[11.84px] mt-4 cursor-pointer"
                    (appClickableDirective)="
                        plantData?.plantPhoto
                          ? previewImage(plantData?.plantPhoto)
                          : null
                      " />
                </div>
              </div>
            </div>
            <hr class="w-full my-5 border-dashed opacity-[50%] bg-[#7C8DB5]" />
            <div>
              @if (statData.plantType !== platType.NON_SOLAR) {
              <div class="lg:w-full">
                <div class="flex justify-between w-full">
                  <div class="h-fit w-fit">
                    <span
                      class="font-roboto lg:h-4 lg:w-[8.4375rem] font-medium leading-[20px] tracking-[2%] text-left text-base dark:text-white">
                      {{ "weather_forecast" | translate }}
                    </span>
                  </div>
                  <div class="h-fit w-fit relative">
                    <span
                      class="font-roboto lg:h-[0.686rem] lg:w-[4.51rem] text-xs font-normal leading-4 text-white tracking-normal text-left cursor-default"
                      (appClickableDirective)="sideSheet.toggle()">
                      {{ "more_detail" | translate }}
                    </span>
                  </div>
                </div>
                <div class="max-w-full w-full relative weather sm:px-8 lg:px-8">
                  <app-weather-forecast></app-weather-forecast>
                </div>
              </div>
              <!-- Weather forecast info card one -->
              <div
                class="flex flex-row mb-5 items-center justify-center mt-5 sm:h-[3.25rem] lg:h-[2.82rem] border-[0.0625rem] rounded-[1.875rem] w-full p-2.5 border-solid border-[#424C57] bg-[#252A30]">
                <div
                  class="flex flex-row h-full justify-between items-center lg:w-full xl:w-full sm:w-11/12 xxl:w-11/12 py-6">
                  <div class="flex items-center">
                    @if (currentWeather && currentWeather.main) {
                    <div>
                      <span
                        class="flex items-center h-5 sm:text-[1.42rem] leading-[100%] lg:text-base justify-center font-medium xl:text-[1.42rems] text-white">
                        {{ currentWeather.main.temp
                        }}<span class="sm:text-[1.18rem] lg:text-sm xl:text-[1.18rem]">°C</span>
                      </span>
                    </div>
                    }

                    <div class="sm:ml-1.5 lg:ml-0.5 xl:ml-2">
                      <span class="flex justify-center items-center sm:text-xs lg:text-sm font-normal text-[#EBEAEB]">
                        {{ "temperature" | translate }}
                      </span>
                    </div>
                  </div>
                  <div class="bg-[#EBEAEB] opacity-[30%] h-6 w-[0.01rem] xl:mx-unset"></div>
                  <div class="flex items-center h-full bg-sky-600">
                    <div>
                      @if (currentWeather && currentWeather.weather) {
                      <span class="flex items-center font-normal text-[#EBEAEB] sm:text-base text-nowrap capitalize">
                        {{ currentWeather!.weather[0].description }}
                      </span>
                      }
                    </div>

                    @if (
                    iconUrl
                    ) {
                    <div class="flex items-center justify-end xl:ml-2">
                      <img [src]="iconUrl" alt="Weather" class="w-6 h-6" />
                    </div>
                    }
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
        <div class="flex flex-col flex-grow gap-3 sm:order-1 lg:order-2">
          <div class="flex items-center w-full justify-between h-fit flex-wrap">
            <div class="flex flex-col justify-between items-start text-lg">
              <div class="flex items-center h-[1.4375rem] w-fit">
                <span class="text-[20px] text-[#EFEDEF] leading-[100%] tracking-wide font-medium text-nowrap">{{
                  selectedPlant?.plantName }}</span>
                @if (!isDeviceOffline) {
                <img src="../../../../../assets/svg/online.svg" alt="Online" class="h-2.5 w-[10.15px] ml-2.5" />
                @if (statData && statData.stats && statData.stats.wifi_signal_strength) {
                <img [src]="
                          '../../../../../assets/svg/' +
                          getStrengthImage(
                            statData.stats.wifi_signal_strength
                          ) +
                          '.svg'
                        " class="w-[12px] h-[11px] ml-2" alt="strength" />
                }
                } @else {
                <div class="flex items-center">
                  <div>
                    <img src="../../../../../assets/svg/offline.svg" alt="Offline world"
                      class="h-2.5 w-[10.15px] ml-2.5" />
                  </div>
                  <div>
                    <app-wifi-icon class="w-[12px] h-[11px] ml-2 text-[#E6E4E4]" />
                  </div>
                </div>
                }
              </div>
              @if (statData) {
              <div class="flex sm:flex-col md:flex-row md:items-center h-fit mt-0.5">
                <div>
                  <span class="text-base text-[#EFEDEF] font-normal">{{
                    statData.deviceId
                    }}</span>
                </div>

                <div>
                  <span class="text-xs leading-[100%] text-[#AEAEAE] md:ml-4 md:-mt-2 font-normal text-[11px]">
                    Last Updated:
                    {{
                    statData.stats!.last_updated_timestamp
                    ? (statData.stats!.last_updated_timestamp * 1000
                    | date: "dd/MM/yyyy hh:mm:ss a")
                    : "NA"
                    }}
                  </span>
                </div>
              </div>
              }
            </div>
            <div class="flex">
              <!--plant info -->
              <div
                class="dark:bg-none py-2.5 px-3 h-[36px] rounded-[32px] border-[0.5px] border-solid border-gray-300 flex items-center gap-2.5 cursor-pointer"
                (appClickableDirective)="navigateToPlantDetail()">
                <span class="text-[#EBEAEB]">
                  {{ "plant_info" | translate }}</span>
                <img src="../../../../../assets/svg/arrow.svg" alt="arrow" />
              </div>
              <!--notification button -->
              <div
                class="relative py-2.5 px-3 h-[36px] ml-2.5 rounded-[32px] border-solid border-[0.5px] border-gray-300 flex items-center justify-center gap-2.5 cursor-pointer"
                (appClickableDirective)="statData ? toggleNotificationDropdown() : null" onClickOutside
                (onClickOutside)="clickOutside('NOTIFICATION')">
                <div>
                  <span class="text-[#EBEAEB]">
                    {{ "notifications" | translate }}
                  </span>
                </div>
                <div class="relative">
                  <img src="../../../../../assets/svg/notification-hut.svg" alt="arrow"
                    class="w-[16.05px] h-[16.03px]" />
                  @if (
                  statData &&
                  notificationList &&
                  notificationList.length > 0
                  ) {
                  <div class="absolute bg-white flex flex-col justify-center items-center rounded-full" [ngClass]="
                          notificationList.length < 10
                            ? 'w-3 h-3 top-[-2px] -right-1'
                            : 'h-[18px] w-[18px] top-[-6px] -right-2'
                        ">
                    <span class="text-black text-[8px] m-0">{{
                      notificationList.length < 10 ? notificationList.length : "10+" }}</span>
                  </div>
                  }
                </div>
                @if(notificationDropdownVisible){
                <div class="absolute min-w-72 z-20 top-8 end-0 shadow-lg" id="dropdown">
                  <!-- Dropdown content -->
                  <div
                    class="flex flex-col mt-2 p-5 rounded-[0.516875 rem] w-[19.0625 rem] h-[38.4375 rem] bg-slateGrey shadow-2xl">
                    <div class="flex flex-row justify-start items-start ml-1">
                      <div>
                        <img src="../../../../../assets/svg/cus_notification.svg" alt="Notification" />
                      </div>
                      <div class="ml-4">
                        <span class="text-white"> Notifications </span>
                      </div>
                    </div>
                    <div class="max-h-96 mt-3.5 overflow-y-auto max-auto-scroll">
                      @for (item of notificationList; track $index) {
                      <div
                        class="flex flex-row justify-start items-start hover:bg-[#E2F1FC] hover:bg-opacity-10 hover: rounded-md py-3"
                        (appClickableDirective)="$event.stopPropagation()">
                        @if (item.data.alertName == "Info Alert") {
                        <img src="../../../../../assets/svg/notification_info.svg" alt="arrow" class="w-9 h-9" />
                        } @else if (
                        item.data.alertName != "Info Alert" &&
                        item.data.blocking == false
                        ) {
                        <img src="../../../../../assets/svg/notification_warning.svg" alt="arrow" class="w-9 h-9" />
                        } @else if (
                        item.data.alertName != "Info Alert" &&
                        item.data.blocking == true
                        ) {
                        <img src="../../../../../assets/svg/notification_alert.svg" alt="arrow" class="w-9 h-9" />
                        }

                        <div class="flex flex-col leading-4 ms-4">
                          <span class="font-medium text-xs text-white">{{
                            item.data.title
                            }}</span>
                          <span class="font-normal leading-[0.808125rem] text-[0.625rem] mt-1.5 text-white">{{
                            item.data.body }}</span>
                          <span class="text-[0.5rem] font-normal leading-[100%] h-2 mt-1.5 text-white">{{
                            item.notificationDate }}</span>
                        </div>
                      </div>
                      }
                    </div>
                  </div>

                </div>}
              </div>
            </div>
          </div>
          <!--subheader-->

          <div
            class="grid grid-rows-1 md:grid-cols-4 sm:grid-cols-2 h-fit overflow-x-auto justify-between gap-3 w-full max-w-full">
            <div
              class="flex flex-row justify-start items-center bg-[#252A30] sm:w-[16.06 rem] md:w-[13.75 rem] lg:h-[4.23rem] px-4 py-2 rounded-[1.25rem] gap-3">
              <div class="rounded-lg w-9 h-9">
                <img src="../../../../../assets/svg/Solar-pv-installled.svg" class="w-8 h-8" alt="icon" />
              </div>
              <div class="flex flex-col flex-grow justify-between">
                <div>
                  <span class="text-[14px] font-normal text-[#AEAEAE]">{{
                    "solar_pv_installed" | translate
                    }}</span>
                </div>
                <div class="mt-2">
                  <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">{{
                    statData.solarPVInstalled ?? "NA" }}</span>
                </div>
              </div>
            </div>
            <div
              class="flex flex-row justify-s sm:w-[16.06 rem] md:w-[13.75 rem] justify-between items-center bg-[#252A30] lg:h-[4.23rem] px-4 py-2 rounded-[1.25rem] gap-3">
              <div>
                <img src="../../../../../assets/svg/Savings.svg" alt="Savings" />
              </div>
              <div class="flex flex-col flex-grow justify-between">
                <div>
                  <span class="text-[14px] font-normal text-[#AEAEAE]">{{
                    "savings" | translate
                    }}</span>
                </div>
                <div class="mt-2">
                  <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">
                    {{
                    statData.totalSavings
                    ? (statData.currencySymbol ?? "₹") +
                    " " +
                    statData.totalSavings
                    : "NA"
                    }}</span>
                </div>
              </div>
            </div>
            <div
              class="flex flex-row justify-start items-center sm:w-[16.06 rem] bg-[#252A30] lg:h-[4.23rem] px-4 py-2 rounded-[1.25rem] gap-3">
              <div class="rounded-lg w-8 h-8">
                <img src="../../../../../assets/svg/ROI.svg" alt="ROI" />
              </div>
              <div class="flex flex-col flex-grow justify-between">
                <div>
                  <span class="text-[14px] font-normal text-[#AEAEAE]">{{
                    "roi" | translate
                    }}</span>
                </div>
                <div class="mt-2">
                  <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">{{ statData.roi ?
                    statData.roi + "%" : "NA" }}
                  </span>
                </div>
              </div>
            </div>
            <div
              class="flex flex-row justify-start items-center sm:w-[16.06 rem] bg-[#252A30] lg:h-[4.23rem] rounded-[1.25rem] px-4 py-2 gap-3">
              <div class="rounded-lg w-9 h-9">
                <img src="../../../../../assets/svg/plant-online-ratioo.svg" class="w-9 h-9" alt="Pie chart" />
              </div>
              <div class="flex flex-col flex-grow justify-between">
                <div>
                  <span class="text-[14px] font-normal text-[#AEAEAE]">{{
                    "plant_online_ratio" | translate
                    }}</span>
                </div>
                <div class="mt-2">
                  @if (
                  plantRatioData?.daysOnline && plantRatioData?.totalDays
                  ) {
                  <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">{{
                    plantRatioData!.daysOnline +
                    "/" +
                    plantRatioData!.totalDays
                    }}</span>
                  <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">Days</span>
                  } @else {
                  <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">NA</span>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="w-full flex gap-3 sm:flex-wrap md:flex-nowrap items-stretch">
            <div
              class="rounded-2xl box1 items-stretch p-5 sm:h-fit sm:min-h-20 md:min-h-32 bg-[#252A30] lg:min-h-96 relative sm:w-full md:w-[39%] lg:w-[37.8%] xl:w-[39%]">
              <app-energy-flow [statData]="statData" class="h-full"
                [plantName]="selectedPlant?.plantName"></app-energy-flow>

            </div>
            <!-- Trends -->
            <div
              class="bg-[#252A30] box2 items-stretch rounded-2xl sm:w-full md:w-unset flex-grow p-5 lg:min-h-96 sm:h-80 md:h-unset sm:max-h-fit">
              <app-trends [plantId]="selectedPlantId" [mappingProtocol]="statData.stats.mappingProtocol"
                [plantType]="statData.plantType"></app-trends>
            </div>
          </div>

        </div>
      </div>


      <div class="flex sm:flex-col lg:flex-row gap-3 lg:mt-3 w-full items-stretch">
        <!--Solar -->
        <div class="flex flex-col sm:w-full rounded-2xl gap-5 lg:w-[57.7%] p-5 bg-[#252A30] md:w-[100%]">
          <div>
            @if (statData.inverterType==inverterType.THINKPOWERHESM) {
            <span class="md:text-lg sm:text-base font-medium text-[#F7FFF7]">
              {{ "energy_summary" | translate }}</span>
            } @else {
            <span class="md:text-lg sm:text-base font-medium text-[#F7FFF7]">
              {{ "solar_summary" | translate }}</span>
            }
            <img src="../../../../../assets/svg/solar-sun.svg" class="ml-2 h-5 w-5" alt="Sun" />
          </div>
          <div class="w-full flex-grow grid grid-cols-4 gap-5 justify-center items-center lg:mb-10 flex-wrap">

            <div class="flex flex-col justify-between w-fit h-fit sm:w-28 lg:w-32 lg:h-[4.5rem]">
              <div>
                <span class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                  {{ "lifetime_generation" | translate }}
                </span>
              </div>
              <div class="mt-3 lg:mt-0">
                <span
                  class="font-roboto text-nowrap font-medium text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                  {{ statData.lifetimeGeneration || "NA" }}
                </span>
              </div>
            </div>
            <div class="flex flex-col justify-between w-fit h-fit sm:w-28 lg:w-32 lg:h-[4.5rem]">
              <div>
                <span class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                  {{ "today_generation" | translate }}
                </span>
              </div>
              <div class="mt-3 lg:mt-0">
                <span
                  class="font-roboto font-medium text-nowrap text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                  {{
                  statData.stats.generation
                  ? statData.stats.generation + " kWh"
                  : "NA"
                  }}
                </span>
              </div>
            </div>

            @if(statData.inverterType==inverterType.THINKPOWERHESM){
            <div class="flex flex-col justify-between w-fit h-fit sm:w-28 lg:w-32 lg:h-[4.5rem]">
              <div>
                <span class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                  {{ "today_consumption" | translate }}
                </span>
              </div>
              <div class="mt-3 lg:mt-0">
                <span
                  class="font-roboto text-nowrap font-medium text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                  {{statData.todayConsumption }}
                </span>
              </div>
            </div>
            <div class="flex flex-col justify-between w-fit h-fit sm:w-28 lg:w-32 lg:h-[4.5rem]">
              <div>
                <span class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                  {{ "lifetime_consumption" | translate }}
                </span>
              </div>
              <div class="mt-3 lg:mt-0">
                <span
                  class="font-roboto text-nowrap font-medium text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                  {{ statData.lifetimeConsumption }}
                </span>
              </div>
            </div>
            }
            @if( statData.inverterType == inverterType.GTI){
            <div class="flex flex-col justify-between w-fit h-fit sm:w-28 lg:w-32 lg:h-[4.5rem]">
              <div>
                <span class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                  {{ "yesteray_generation" | translate }}
                </span>
              </div>
              <div class="mt-3 lg:mt-0">
                <span
                  class="font-roboto text-nowrap font-medium text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                  {{ statData.stats.energyYesterday || "NA" }}
                </span>
              </div>
            </div>
            <div class="flex flex-col justify-between w-fit h-fit sm:w-28 lg:w-32 lg:h-[4.5rem]">
              <div>
                <span class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                  {{ "this_month_generation" | translate }}
                </span>
              </div>
              <div class="mt-3 lg:mt-0">
                <span
                  class="font-roboto text-nowrap font-medium text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                  {{ statData.stats.energyThisMonth || "NA" }}
                </span>
              </div>
            </div>

            <div class="flex flex-col justify-between h-fit w-fit sm:w-28 lg:w-32 lg:h-[4.5rem]">
              <div>
                <span class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                  {{ "last_month_generation" | translate }}
                </span>
              </div>
              <div class="mt-3 lg:mt-0">
                <span
                  class="font-roboto text-nowrap font-medium text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                  {{ statData.stats.energyLastMonth || "NA" }}
                </span>
              </div>
            </div>
            <div class="flex flex-col justify-between h-fit w-fit sm:w-28 lg:w-32 lg:h-[4.5rem]">
              <div>
                <span class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                  {{ "this_year_generation" | translate }}
                </span>
              </div>
              <div class="mt-3 lg:mt-0">
                <span
                  class="font-roboto text-nowrap font-medium text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                  {{ statData.stats.energyThisYear || "NA" }}
                </span>
              </div>
            </div>
            <div class="flex flex-col justify-between h-fit w-fit sm:w-28 lg:w-32 lg:h-[4.5rem]">
              <div>
                <span class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                  {{ "last_year_generation" | translate }}
                </span>
              </div>
              <div class="mt-3 lg:mt-0">
                <span
                  class="font-roboto text-nowrap font-medium text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                  {{ statData.stats.energyLastYear || "NA" }}
                </span>
              </div>
            </div>}
          </div>
        </div>
        <!--Environmental Benefits -->
        <div class="lg:flex-grow "> <app-environmental-benefits
            [equivalentTreesPlanted]="statData.equivalentTreesPlanted" [co2EmissionSaved]="statData.co2EmissionSaved"
            [coalNotBurned]="statData.coalNotBurned"></app-environmental-benefits>
        </div>
      </div>

    </div>
    } @else{
    <ng-container [ngTemplateOutlet]="otherInverterType"></ng-container>
    }
    <!---Template for other Inverter Types is here -->
    <ng-template #otherInverterType>
      <div
        class="w-full flex items-stretch main-template h-fit sm:flex-col lg:flex-row flex-grow sm:px-8 sm:py-6 lg:px-8 lg:py-8 sm:gap-3 lg:gap-0 md:gap-3 overflow-auto scrollbar-custom">
        <div
          class="sm:w-full child-one lg:w-[35%] xl:w-[39%] items-stretch lg:h-unset lg:flex-grow sm:pt-5 sm:px-5 sm:pb-2 md:pt-5 md:pr-4 md:pb-5 md:pl-6 lg:pt-5 lg:pr-5 lg:pl-5 lg:pb-2.5 rounded-[1.25rem] bg-[#252A30] sm:h-[68px] sm:order-2 lg:order-1"
          [ngClass]="{ increaseBoxSize: increaseInfoBoxSize }">
          <div class="flex items-center justify-between sm:h-full lg:h-fit w-full leading-full gap-3"
            (appClickableDirective)="increaseSize()" [ngClass]="{ changeLineHeight: changeLineHeight }">
            <div>
              <span class="font-roboto font-normal tracking-[2%] w-[25px] text-left sm:text-base md:text-lg text-white">
                {{ "general_info" | translate }}
              </span>
            </div>
            <div class="sm:block lg:hidden" [ngClass]="{ changeRotation: changeRotation }">
              <img src="../../../../../assets/svg/opener-icon.svg" alt="Opener" />
            </div>
          </div>
          <div class="w-full h-full flex flex-col sm:hidden lg:flex" [ngClass]="{ showGeneralInfo: showGeneralInfo }">
            <div>
              @if (user && user.user_type === userType.SYSTEM_INTEGRATOR) {
              <div class="hidden space-x-2" (appClickableDirective)="goBack()">
                <img src="../../../../assets/svg/arrow_back.svg" class="rotate-180" alt="Back" />
                <span class="text-gray-100 gradient-text">{{
                  "back" | translate
                  }}</span>
              </div>
              }

              <!-- General info card one -->
              <div class="flex lg:justify-between mt-3 sm:w-fit lg:w-full">
                <div class="flex flex-col w-fit">
                  <div class="flex justify-between flex-col w-fit">
                    <div>
                      <span
                        class="font-roboto sm:text-sm ml-0 font-normal md:text-base tracking-normal text-left opacity-50 text-white">
                        {{ "model_name" | translate }}
                      </span>
                    </div>
                    <div class="mt-1 lg:mt-1.5 xl:mt-2">
                      <span class="font-roboto sm:text-sm font-normal tracking-normal text-left text-white">
                        {{ statData.inverterModel}}
                      </span>
                    </div>
                  </div>
                  @if(statData.inverterType!=inverterType.ENERTECH_SOLAR &&
                  statData.inverterType!=inverterType.ENERTECH_NON_SOLAR &&
                  statData.inverterType!=inverterType.OPTIMUS_3P &&statData.inverterType!=inverterType.ARCTIC_HYBRID){
                  <div class="mt-[1.26rem] 
                  ">
                    <div>
                      <span
                        class="font-roboto text-sm ml-0 font-normal tracking-normal text-left opacity-50 dark:text-white">
                        {{ "operating_mode" | translate }}
                      </span>
                    </div>
                    <div class="mt-1 lg:mt-1.5 xl:mt-2">
                      <span class="font-roboto text-sm font-normal tracking-normal text-left dark:text-white">
                        {{ statData.operatingMode || "NA" }}
                      </span>
                    </div>
                  </div>}
                </div>
                <div class="flex lg:justify-end sm:ml-12 md:ml-14 lg:ml-unset">
                  <img [src]="
                        plantData?.plantPhoto ||
                        '../../../../../assets/images/plantdefault.svg'
                      " alt="preview"
                    class="sm:w-[10.31rem] sm:h-[5.50rem] md:h-[5.5031rem] lg:h-[4.77rem] lg:w-[6.86rem] rounded-[11.84px] mt-4 cursor-pointer"
                    (appClickableDirective)="
                        plantData?.plantPhoto
                          ? previewImage(plantData?.plantPhoto)
                          : null
                      " />
                </div>
              </div>
              @if (
              statData.inverterType == inverterType.SOLARVERTERPRO ||
              statData.inverterType == inverterType.HYBRID ||
              statData.inverterType == inverterType.PCU
              ) {
              <!-- General info card two -->
              <div
                class="grid-container-first mt-6 sm:w-full h-fit lg:pr-2.5 xl:px-0 sm:justify-between xl:[justify-content:unset]">
                <!--First-part -->
                <div class="flex-col flex sm:w-36 lg:w-[5rem]">
                  <div class="flex flex-col w-full justify-between sm:w-52 lg:w-full sm:h-14 lg:h-[2.375rem] gap-3">
                    <div class="w-full">
                      <span class="font-roboto font-normal text-left text-sm text-[#AEAEAE]">
                        {{ "pv_voltage" | translate }}
                      </span>
                    </div>
                    <div class="lg:w-full">
                      <span class="font-roboto text-sm font-normal tracking-normal text-left text-[#EBEAEB]">
                        {{ statData.solarVoltage?.toString() || "0" }} V
                      </span>
                    </div>
                  </div>
                  <div
                    class="xxl:mt-9 lg:mt-6 sm:mt-6 flex flex-col justify-between sm:w-52 lg:w-full gap-3 sm:h-14 lg:h-[4.3125rem]">
                    <div class="lg:w-full lg:h-[1.9375rem]">
                      <span
                        class="font-roboto font-normal text-left text-wrap text-sm text-[#AEAEAE] leading-[100%] tracking-[0%]">
                        {{ "battery_chrg_current" | translate }}
                      </span>
                    </div>
                    <div class="lg:w-full lg:h-4">
                      <span class="font-roboto text-sm font-normal tracking-normal text-left text-[#EBEAEB]">
                        {{
                        statData.stats.charging_current?.toString() ||
                        "0"
                        }}
                        A
                      </span>
                    </div>
                  </div>
                  @if (this.statData &&
                  (this.statData.inverterType === inverterType.HYBRID)
                  ) {
                  <div class="xxl:mt-8 lg:mt-5 sm:mt-6">
                    <div class="w-full">
                      <span class="font-roboto font-normal text-left text-sm text-[#AEAEAE]">
                        {{ "grid_current" | translate }}
                      </span>
                    </div>
                    <div class="lg:w-full mt-1.5">
                      <span class="font-roboto text-sm font-normal tracking-normal text-left text-[#EBEAEB]">
                        {{
                        statData.stats.gridCTCurrent?.toString() ||
                        "0"
                        }}
                        A
                      </span>
                    </div>
                  </div>
                  }
                </div>
                <!--Second-part-->
                <div class="flex-col flex sm:w-36 lg:w-[5rem]">
                  <div class="sm:w-52 lg:w-full sm:h-14 lg:h-[2.375rem] flex flex-col justify-between gap-3">
                    <div>
                      <span class="font-roboto font-normal leading-[100%] text-left text-sm text-[#AEAEAE]">
                        {{ "pv_current" | translate }}
                      </span>
                    </div>
                    <div>
                      <span class="font-roboto text-sm font-normal tracking-normal text-lef text-[#EBEAEB]">
                        {{ statData.stats.pvCurrent?.toString() || "0" }}
                        A
                      </span>
                    </div>
                  </div>
                  <div
                    class="xxl:mt-9 lg:mt-6 sm:mt-6 flex flex-col justify-between sm:w-52 gap-3 lg:w-full sm:h-14 lg:h-[4.3125rem]">
                    <div class="lg:w-full lg:h-[1.9375rem]">
                      <span
                        class="font-roboto font-normal text-left text-sm text-[#AEAEAE] leading-[100%] tracking-[0%]">
                        {{ "output_voltage" | translate }}
                      </span>
                    </div>
                    <div class="lg:w-full lg:h-4">
                      <span class="font-roboto text-sm font-normal tracking-normal text-left text-[#EBEAEB]">
                        {{ statData.outputVoltage?.toString() || "0" }} V
                      </span>
                    </div>
                  </div>
                </div>
                <!--Third-part-->
                <div class="flex-col flex sm:w-36 lg:w-[5rem]">
                  <div class="flex flex-col justify-between sm:w-52 lg:w-full sm:h-14 lg:h-[2.375rem] gap-3">
                    <div class="lg:w-full">
                      <span class="font-roboto font-normal text-left text-sm text-nowrap text-[#AEAEAE]">
                        {{ "battery_voltage" | translate }}
                      </span>
                    </div>
                    <div class="lg:w-full">
                      <span class="font-roboto text-sm font-normal tracking-normal text-left text-[#EBEAEB]">
                        {{ statData.batteryVoltage?.toString() || "0" }} V
                      </span>
                    </div>
                  </div>
                  @if (
                  statData.inverterType ===
                  inverterType.SOLARVERTERPRO ||
                  statData.inverterType === inverterType.PCU
                  ) {
                  <div
                    class="xxl:mt-9 lg:mt-6 sm:mt-6 gap-3 flex flex-col justify-between sm:w-52 lg:w-full sm:h-14 mt-0.5 lg:h-[4.3125rem]">
                    <div class="lg:w-full lg:h-[1.9375rem]">
                      <span
                        class="font-roboto font-normal text-left text-wrap text-sm leading-[100%] tracking-[0%] text-[#AEAEAE]">
                        {{ "load_percentage" | translate }}(%)
                      </span>
                    </div>
                    <div class="lg:w-full lg:h-4">
                      <span class="font-roboto text-sm font-normal tracking-normal text-left text-[#EBEAEB]">
                        {{
                        statData.stats.current_running_load_percentage
                        }}
                        %
                      </span>
                    </div>
                  </div>
                  } @else {
                  <div
                    class="xxl:mt-9 lg:mt-6 sm:mt-6 flex flex-col justify-between sm:w-52 lg:w-full gap-3 sm:h-14 lg:h-[4.3125rem]">
                    <div class="lg:w-full lg:h-[1.9375rem]">
                      <span
                        class="font-roboto font-normal text-left text-wrap text-sm text-[#AEAEAE] leading-[100%] tracking-[0%]">
                        {{ "output_current" | translate }}
                      </span>
                    </div>
                    <div class="lg:w-full lg:h-4">
                      <span class="font-roboto text-sm font-normal tracking-normal text-left text-[#EBEAEB]">
                        {{
                        statData.stats.inverterCurrent?.toString() ||
                        "0"
                        }}
                        A
                      </span>
                    </div>
                  </div>
                  }
                </div>
              </div>
              }
              @else if (this.statData.plantType === platType.NON_SOLAR &&
              statData.inverterType!==inverterType.ENERTECH_NON_SOLAR && statData.inverterType!=inverterType.OPTIMUS_3P)
              {
              <!-- General info card two left to do -->
              <div class="grid-container-second gap-[1.4375rem] mt-6 w-fit h-fit">
                <!--1st part-->
                <div class="lg:h-[2.375rem] md:h-[3.125rem] sm:h-[2.375rem] gap-3">
                  <div class="h-fit">
                    <span
                      class="font-roboto h-2.5 sm:text-sm md:text-xl lg:text-sm leading-[100%] font-normal tracking-normal text-left text-[#AEAEAE]">
                      {{ "battery_voltage" | translate }}
                    </span>
                  </div>
                  <div class="h-fit">
                    <span
                      class="font-roboto h-[1.4375rem] lg:text-sm md:text-xl sm:text-sm leading-[100%] font-normal tracking-normal text-left text-[#EBEAEB]">
                      {{ statData.batteryVoltage?.toString() || "0" }} V
                    </span>
                  </div>
                </div>
                <!--2nd part -->
                <div
                  class="lg:h-[2.375rem] md:h-[3.125rem] sm:h-[2.375rem] w-fit gap-3 sm:ml-3 lg:ml-2 lg:mr-10 xl:mr-12 xxl:mr-14">
                  <div class="h-fit">
                    <span
                      class="font-roboto h-2.5 text-nowrap sm:text-sm md:text-xl lg:text-sm leading-[100%] font-normal tracking-normal text-left text-[#AEAEAE]">
                      {{ "battery_chrg_current" | translate }}
                    </span>
                  </div>
                  <div class="h-fit">
                    <span
                      class="font-roboto h-[1.4375rem] lg:text-sm md:text-xl sm:text-sm leading-[100%] font-normal tracking-normal text-left text-[#EBEAEB]">
                      {{
                      statData.stats.charging_current?.toString() || "0"
                      }}
                      A
                    </span>
                  </div>
                </div>
                <!--3rd part -->
                <div class="lg:h-[2.375rem] sm:w-[10rem] md:h-[3.125rem] sm:h-[2.375rem] gap-3">
                  <div class="h-fit">
                    <span
                      class="font-roboto h-2.5 sm:text-sm md:text-xl lg:text-sm leading-[100%] font-normal tracking-normal text-left text-[#AEAEAE]">
                      {{ "output_voltage" | translate }}
                    </span>
                  </div>
                  <div class="h-fit">
                    <span
                      class="font-roboto h-[1.4375rem] lg:text-sm md:text-xl sm:text-sm leading-[100%] font-normal tracking-normal text-left text-[#EBEAEB]">
                      {{ statData.outputVoltage?.toString() || "0" }} V
                    </span>
                  </div>
                </div>
                <!--4th part-->
                <div
                  class="lg:h-[2.375rem] lg:ml-2 sm:ml-3 md:h-[3.125rem] sm:h-[2.375rem] gap-3 lg:mr-10 xl:mr-12 xxl:mr-14">
                  <div class="h-fit">
                    <span
                      class="font-roboto h-2.5 sm:text-sm md:text-xl lg:text-sm leading-[100%] font-normal tracking-normal text-left text-[#AEAEAE]">
                      {{ "load_percentage" | translate }}
                    </span>
                  </div>
                  <div class="h-fit">
                    <span
                      class="font-roboto h-[1.4375rem] lg:text-sm md:text-xl sm:text-sm leading-[100%] font-normal tracking-normal text-left text-[#EBEAEB]">
                      {{
                      statData.stats.current_running_load_percentage?.toString() ||
                      "0"
                      }}
                      %
                    </span>
                  </div>
                </div>
              </div>
              }
            </div>
            <hr class="w-full my-5 border-dashed opacity-[50%] bg-[#7C8DB5]" />
            <div>
              @if (statData.plantType !== platType.NON_SOLAR) {
              <div class="lg:w-full">
                <div class="flex justify-between w-full">
                  <div class="h-fit w-fit">
                    <span
                      class="font-roboto lg:h-4 lg:w-[8.4375rem] font-medium leading-[20px] tracking-[2%] text-left text-base dark:text-white">
                      {{ "weather_forecast" | translate }}
                    </span>
                  </div>
                  <div class="h-fit w-fit">
                    <span
                      class="font-roboto lg:h-[0.686rem] lg:w-[4.51rem] text-xs font-normal leading-4 text-white tracking-normal text-left cursor-default"
                      (appClickableDirective)="sideSheet.toggle()">
                      {{ "more_detail" | translate }}
                    </span>
                  </div>
                </div>
                <div class="max-w-full w-full weather">
                  <app-weather-forecast></app-weather-forecast>
                </div>
              </div>
              <!-- Weather forecast info card one -->
              <div
                class="flex flex-row items-center justify-center sm:h-[3.25rem] lg:h-[2.82rem] border-[0.0625rem] rounded-[30px] w-full sm:mt-5 xl:mt-6 p-2.5 border-solid border-[#424C57] bg-[#252A30]">
                <div class="flex flex-row h-full justify-between items-center lg:w-full sm:w-8/12 py-6 xl:px-2">
                  <div class="flex items-center">
                    @if (currentWeather && currentWeather.main) {
                    <div>
                      <span
                        class="flex items-center h-5 sm:text-[1.42rem] leading-[100%] justify-center font-medium text-[1.42rems] text-white">
                        {{ currentWeather.main.temp
                        }}<span class="sm:text-[1.18rem]">°C</span>
                      </span>
                    </div>
                    }

                    <div class="sm:ml-1.5">
                      <span class="flex justify-center items-center sm:text-xs lg:text-sm font-normal text-[#EBEAEB]">
                        {{ "temperature" | translate }}
                      </span>
                    </div>
                  </div>
                  <div class="bg-[#EBEAEB] opacity-[30%] h-6 w-[0.01rem] lg:mx-2 xl:mx-unset"></div>
                  <div class="flex items-center h-full bg-sky-600">
                    <div>
                      @if (currentWeather && currentWeather.weather) {
                      <span class="flex items-center font-normal text-[#EBEAEB] sm:text-base text-nowrap capitalize">
                        {{ currentWeather!.weather[0].description }}
                      </span>
                      }
                    </div>

                    @if (
                    iconUrl
                    ) {
                    <div class="flex items-center justify-end">
                      <img [src]="iconUrl" alt="Weather" class="w-6 h-6" />
                    </div>
                    }
                  </div>
                </div>
              </div>
              }

              @if (
              (statData &&
              statData.inverterType != inverterType.GTI &&
              statData.inverterType != inverterType.ThinkPower && statData.inverterType!=inverterType.ENERTECH_SOLAR
              ) ||
              (statData && statData.plantType == platType.NON_SOLAR)
              ) {
              <!-- Insights-->
              <div class="mt-6">
                <span
                  class="text-[#EFEDEF] font-roboto font-medium tracking-[2%] text-left leading-5 sm:text-base md:text-lg lg:text-base h-4 w-[3.75 rems]">{{
                  "insights" | translate }}
                </span>

                <div
                  class="flex bg-[#535E6A] gap-2 px-5 pt-5 pb-3 mt-4 sm:w-full md:h-[ 9.4375 rems] sm:h-[6.3125 rems] lg:h-fit lg:w-[94%] gap-2 rounded-[0.6875rem]">
                  <div class="col-span-1 justify-self-center hidden">
                    <div class="rounded-full w-9 h-9 flex justify-center items-center">
                      <img src="../../../../../assets/svg/energy_freedom.svg" alt="insight" class="w-4 h-4" />
                    </div>
                  </div>

                  <div class="flex flex-col w-full">
                    @if (statData.plantType === platType.SOLAR) {
                    <div class="w-full">
                      <span class="lg:text-base md:text-xl sm:text-sm tracking-[2%] text-white font-medium">
                        {{ "energy_freedom" | translate }}
                        {{ statData.solarPecentInConsumption || 0 }}%
                        {{ "self_powered" | translate }}
                      </span>
                    </div>

                    <div class="w-full mt-2.5">
                      <span class="lg:text-sm md:text-xl font-normal sm:text-sm tracking-[2%] text-[#F7FFF7]">
                        Yesterday,
                        {{ statData.solarPecentInConsumption || 0 }}% of
                        your home’s power was provided by clean, green
                        solar energy, making a positive impact on the
                        environment.
                      </span>
                    </div>
                    } @else {
                    <div class="w-full">
                      <span class="lg:text-base md:text-xl sm:text-sm tracking-[2%] text-white font-medium">
                        {{ "Power Backup" | translate }}
                      </span>
                    </div>

                    @if(!statData.totalPowerBackup){
                    <div class="w-full mt-2">
                      <span class="lg:text-sm md:text-xl font-normal sm:text-sm tracking-[2%] text-[#F7FFF7]">
                        Yesterday ,There was no power cut
                      </span>
                    </div>
                    } @else {
                    <div class="w-full mt-2">
                      <span class="lg:text-sm md:text-xl font-normal sm:text-sm tracking-[2%] text-[#F7FFF7]">
                        Yesterday, your system had provided
                        {{ statData.totalPowerBackup }}
                        power backup
                      </span>
                    </div>
                    }

                    }
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
        <div class="flex flex-col flex-grow sm:w-full gap-3 lg:ml-3 sm:order-1 lg:order-2 items-stretch">
          <div class="flex items-center w-full justify-between h-fit flex-wrap">
            <div class="flex flex-col justify-between items-start text-lg">
              <div class="flex items-center h-[23px]">
                <span class="text-[20px] text-[#EFEDEF] leading-[100%] tracking-wide font-medium text-nowrap">{{
                  selectedPlant?.plantName }}</span>
                @if (!isDeviceOffline) {
                <img src="../../../../../assets/svg/online.svg" alt="Online" class="h-2.5 w-[10.15px] ml-2.5" />
                @if (statData && statData.stats && statData.stats.wifi_signal_strength) {
                <img [src]="
                          '../../../../../assets/svg/' +
                          getStrengthImage(
                            statData.stats.wifi_signal_strength
                          ) +
                          '.svg'
                        " class="w-[12px] h-[11px] ml-2" alt="strength" />
                }
                } @else {
                <div class="flex items-center">
                  <div>
                    <img src="../../../../../assets/svg/offline.svg" alt="Offline world"
                      class="h-2.5 w-[10.15px] ml-2.5" />
                  </div>
                  <div>
                    <app-wifi-icon class="w-[12px] h-[11px] ml-2 text-[#E6E4E4]" />
                  </div>
                </div>
                }
              </div>
              @if (statData) {
              <div class="flex sm:flex-col md:flex-row md:items-center h-fit mt-0.5">
                <div>
                  <span class="text-base text-[#EFEDEF] font-normal">{{
                    statData.deviceId
                    }}</span>
                </div>

                <div>
                  <span class="text-xs leading-[100%] text-[#AEAEAE] md:ml-4 md:-mt-2 font-normal text-[11px]">
                    Last Updated:
                    {{
                    statData.stats!.last_updated_timestamp
                    ? (statData.stats!.last_updated_timestamp * 1000
                    | date: "dd/MM/yyyy hh:mm:ss a")
                    : "NA"
                    }}
                  </span>
                </div>
              </div>
              }
            </div>
            <div class="flex">
              <!--plant info -->
              <div
                class="dark:bg-none py-2.5 px-3 h-[36px] rounded-[32px] border-[0.5px] border-solid border-gray-300 flex items-center gap-2.5 cursor-pointer"
                (appClickableDirective)="navigateToPlantDetail()">
                <span class="text-[#EBEAEB]">
                  {{ "plant_info" | translate }}</span>
                <img src="../../../../../assets/svg/arrow.svg" alt="arrow" />
              </div>
              <!--notification button -->
              <div
                class="relative py-2.5 px-3 h-[36px] ml-2.5 rounded-[32px] border-solid border-[0.5px] border-gray-300 flex items-center justify-center gap-2.5 cursor-pointer"
                (appClickableDirective)="statData ? toggleNotificationDropdown() : null" onClickOutside
                (onClickOutside)="clickOutside('NOTIFICATION')">
                <div>
                  <span class="text-[#EBEAEB]">
                    {{ "notifications" | translate }}
                  </span>
                </div>
                <div class="relative">
                  <img src="../../../../../assets/svg/notification-hut.svg" alt="arrow"
                    class="w-[16.05px] h-[16.03px]" />
                  @if (
                  statData &&
                  notificationList &&
                  notificationList.length > 0
                  ) {
                  <div class="absolute bg-white flex flex-col justify-center items-center rounded-full" [ngClass]="
                          notificationList.length < 10
                            ? 'w-3 h-3 top-[-2px] -right-1'
                            : 'h-[18px] w-[18px] top-[-6px] -right-2'
                        ">
                    <span class="text-black text-[8px] m-0">{{
                      notificationList.length < 10 ? notificationList.length : "10+" }}</span>
                  </div>
                  }
                </div>
                @if (notificationDropdownVisible) {
                <div class="absolute min-w-72 z-20 top-8 end-0 shadow-lg">
                  <!-- Dropdown content -->
                  <div
                    class="flex flex-col mt-2 p-5 rounded-[0.516875 rem] w-[19.0625 rem] h-[38.4375 rem] bg-slateGrey shadow-2xl">
                    <div class="flex flex-row justify-start items-start ml-1">
                      <div>
                        <img src="../../../../../assets/svg/cus_notification.svg" alt="Notification" />
                      </div>
                      <div class="ml-4">
                        <span class="text-white"> Notifications </span>
                      </div>
                    </div>
                    <div class="max-h-96 overflow-y-auto max-auto-scroll">
                      @for (item of notificationList; track $index) {
                      <div
                        class="flex flex-row justify-start items-start hover:bg-[#E2F1FC] hover:bg-opacity-10 hover: rounded-md py-3"
                        (appClickableDirective)="$event.stopPropagation()">
                        @if (item.data.alertName == "Info Alert") {
                        <img src="../../../../../assets/svg/notification_info.svg" alt="arrow" class="w-9 h-9" />
                        } @else if (
                        item.data.alertName != "Info Alert" &&
                        item.data.blocking == false
                        ) {
                        <img src="../../../../../assets/svg/notification_warning.svg" alt="arrow" class="w-9 h-9" />
                        } @else if (
                        item.data.alertName != "Info Alert" &&
                        item.data.blocking == true
                        ) {
                        <img src="../../../../../assets/svg/notification_alert.svg" alt="arrow" class="w-9 h-9" />
                        }

                        <div class="flex flex-col leading-4 ms-4">
                          <span class="font-medium text-xs text-white">{{
                            item.data.title
                            }}</span>
                          <span class="font-normal leading-[0.808125rem] text-[0.625rem] mt-1.5 text-white">{{
                            item.data.body }}</span>
                          <span class="text-[0.5rem] font-normal leading-[100%] h-2 mt-1.5 text-white">{{
                            item.notificationDate }}</span>
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                  <!--Dropdown content end here-->
                </div>}
              </div>
            </div>
          </div>


          <div class="flex-col flex gap-3 items">
            @if (statData.plantType !== platType.NON_SOLAR) {
            <!-- Top header -->

            <div class="w-full h-fit">
              <div
                class="grid grid-rows-1 md:grid-cols-4 sm:grid-cols-2 h-fit overflow-x-auto justify-between gap-3 w-full max-w-full">
                <div
                  class="flex flex-row justify-start items-center bg-[#252A30] sm:w-[16.06 rem] md:w-[13.75 rem] lg:h-[4.23rem] px-4 py-2 rounded-[20px] gap-3">
                  <div class="rounded-lg w-9 h-9">
                    <img src="../../../../../assets/svg/Solar-pv-installled.svg" class="w-8 h-8" alt="icon" />
                  </div>
                  <div class="flex flex-col flex-grow justify-between">
                    <div>
                      <span class="text-[14px] font-normal text-[#AEAEAE]">{{ "solar_pv_installed" | translate }}</span>
                    </div>
                    <div class="mt-2">
                      <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">{{
                        statData.solarPVInstalled ?? "NA" }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="flex flex-row justify-s sm:w-[16.06 rem] md:w-[13.75 rem] justify-between items-center bg-[#252A30] lg:h-[4.23rem] px-4 py-2 rounded-[20px] gap-3">
                  <div>
                    <img src="../../../../../assets/svg/Savings.svg" alt="Savings" />
                  </div>
                  <div class="flex flex-col flex-grow justify-between">
                    <div>
                      <span class="text-[14px] font-normal text-[#AEAEAE]">{{ "savings" | translate }}</span>
                    </div>
                    <div class="mt-2">
                      <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">
                        {{
                        statData.totalSavings
                        ? (statData.currencySymbol ?? "₹") +
                        " " +
                        statData.totalSavings
                        : "NA"
                        }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="flex flex-row justify-start items-center sm:w-[16.06 rem] bg-[#252A30] lg:h-[4.23rem] px-4 py-2 rounded-[20px] gap-3">
                  <div class="rounded-lg w-8 h-8">
                    <img src="../../../../../assets/svg/ROI.svg" alt="ROI" />
                  </div>
                  <div class="flex flex-col flex-grow justify-between">
                    <div>
                      <span class="text-[14px] font-normal text-[#AEAEAE]">{{ "roi" | translate }}</span>
                    </div>
                    <div class="mt-2">
                      <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">{{ statData.roi ?
                        statData.roi + "%" : "NA" }}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  class="flex flex-row justify-start items-center sm:w-[16.06 rem] bg-[#252A30] lg:h-[4.23rem] rounded-[20px] px-4 py-2 gap-3">
                  <div class="rounded-lg w-9 h-9">
                    <img src="../../../../../assets/svg/plant-online-ratioo.svg" class="w-9 h-9" alt="Pie chart" />
                  </div>
                  <div class="flex flex-col flex-grow justify-between">
                    <div>
                      <span class="text-[14px] font-normal text-[#AEAEAE]">{{ "plant_online_ratio" | translate }}</span>
                    </div>
                    <div class="mt-2">
                      @if (
                      plantRatioData?.daysOnline &&
                      plantRatioData?.totalDays
                      ) {
                      <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">{{
                        plantRatioData!.daysOnline +
                        "/" +
                        plantRatioData!.totalDays
                        }}</span>
                      <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">Days</span>
                      } @else {
                      <span class="text-[#EBEAEB] font-medium text-base leading-[100%] tracking-[2%]">NA</span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }
            <div class="h-fit flex flex-wrap gap-3">
              <!-- Preview GTI flow -->
              <div class="w-full flex gap-3 sm:flex-wrap md:flex-nowrap items-stretch">
                <div
                  class="rounded-2xl box1 p-5 bg-[#252A30] items-stretch sm: xl:h-unset sm:w-full md:w-[42.5%] lg:w-[43%]">
                  <app-energy-flow [statData]="statData" class="h-full"></app-energy-flow>
                </div>
                <!-- Trends -->
                <div
                  class="bg-[#252A30] box2 items-stretch rounded-2xl xl:h-unset sm:w-full md:w-unset flex-grow p-5 sm:h-80 lg:min-h-96 md:h-unset sm:max-h-fit">
                  <app-trends [plantId]="selectedPlantId" [mappingProtocol]="statData.stats.mappingProtocol"
                    [plantType]="statData.plantType"></app-trends>
                </div>
              </div>

              <div class="h-fit w-full">
                <!-- Solar summary and environment benifits -->
                @if (statData.plantType !== platType.NON_SOLAR ) {
                <div class="flex sm:flex-col md:flex-row gap-3 w-full items-stretch">
                  <!--Solar -->
                  <div class="flex flex-col sm:w-full rounded-2xl gap-5 lg:w-[43%] p-5 bg-[#252A30] md:w-[42.5%]">

                    <div class="w-full flex justify-between">
                      <div>

                        <span class="md:text-lg sm:text-base font-medium text-[#F7FFF7]">
                          {{
                          generationData
                          ? ("solar_summary" | translate)
                          : ("energy_summary" | translate)
                          }}
                        </span>

                        <img src="../../../../../assets/svg/solar-sun.svg" class="ml-2 h-5 w-5" alt="Sun" />
                      </div>
                      @if(statData.inverterType===inverterType.ARCTIC_HYBRID){
                      <div
                        class="relative px-3 py-[1px]  text-black dark:text-white rounded-2xl border-solid border-[1px] border-gray-300 flex items-center space-x-1 cursor-default"
                        (appClickableDirective)="toggleTrendDropdown()" onClickOutside (onClickOutside)="clickOutside('TREND_TYPE')">
                        <span class="text-xs p-0 gradient-header no-underline">{{
                          selectedTrend.value
                          }}</span>
                        <img src="../../../../../assets/svg/dropdown_icon.svg" alt="arrow" class="w-3 h-3" />
                        @if(enableTrendDropdown){
                        <div class="absolute min-w-32 p-2 z-30 start-0 end-5 top-4" id="dropdown">
                          <!-- Dropdown content -->
                          <div
                            class="flex flex-col mt-2 rounded-lg bg-dark-gray-light lg:px-2 sm:px-1 pb-2 small-square">
                            @for (item of trendDropdown; track $index) {
                            <span class="text-xs gradient-header no-underline pt-2"
                              (appClickableDirective)="switchTrends(item)">
                              {{ item.value }}
                            </span>
                            }
                          </div>
                        </div>}
                      </div>}
                    </div>
                    @if (generationData) {
                    <div class="w-full flex-grow flex justify-center items-center">
                      <div
                        class="flex flex-row items-stretch justify-between lg:mt-[1rem] sm:mt-2 md:mt-0 sm:w-10/12 md:w-full xxl:w-10/12 sm:mb-3">
                        <div class="flex flex-col justify-between w-fit h-fit">
                          <div>
                            <span
                              class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                              {{ "today_generation" | translate }}
                            </span>
                          </div>
                          <div class="mt-5">
                            <span
                              class="font-roboto font-medium text-nowrap text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                              {{
                              statData.stats.generation
                              ? statData.stats.generation + " kWh"
                              : "NA"
                              }}
                            </span>
                          </div>
                        </div>
                        <div>
                          <div class="bg-[#AEAEAE] w-0.5 h-full"></div>
                        </div>
                        <div class="flex flex-col justify-between h-fit w-fit">
                          <div>
                            <span
                              class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                              {{ "lifetime_generation" | translate }}
                            </span>
                          </div>
                          <div class="mt-5">
                            <span
                              class="font-roboto font-medium text-nowrap text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                              {{ statData.lifetimeGeneration || "NA" }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>}
                    @if(!generationData){
                    <div class="w-full flex-grow flex justify-center items-center">
                      <div
                        class="flex flex-row items-stretch justify-between lg:mt-[1rem] sm:mt-2 md:mt-0 sm:w-10/12 md:w-full xxl:w-10/12 sm:mb-3">
                        <div class="flex flex-col justify-between w-fit h-fit">
                          <div>
                            <span
                              class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                              {{ "today_consumption" | translate }}
                            </span>
                          </div>
                          <div class="mt-5">
                            <span
                              class="font-roboto font-medium text-nowrap text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                              {{
                              statData.todayConsumption
                              }}
                            </span>
                          </div>
                        </div>
                        <div>
                          <div class="bg-[#AEAEAE] w-0.5 h-full"></div>
                        </div>
                        <div class="flex flex-col justify-between h-fit w-fit">
                          <div>
                            <span
                              class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                              {{ "lifetime_consumption" | translate }}
                            </span>
                          </div>
                          <div class="mt-5">
                            <span
                              class="font-roboto font-medium text-nowrap text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                              {{ statData.lifetimeConsumption || "NA" }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>}
                  </div>
                  <!--Environmental Benefits-->
                  <div class="md:flex-grow">

                    <app-environmental-benefits [equivalentTreesPlanted]="statData.equivalentTreesPlanted"
                      [co2EmissionSaved]="statData.co2EmissionSaved"
                      [coalNotBurned]="statData.coalNotBurned"></app-environmental-benefits>
                  </div>
                </div>
                }

                @if (
                statData.plantType === platType.NON_SOLAR &&
                statData.stats.mappingProtocol != "BITWISE" && statData.inverterType!==inverterType.ENERTECH_NON_SOLAR
                && statData.inverterType!==inverterType.OPTIMUS_3P
                ) {
                <div class="flex flex-col bg-[#252A30] rounded-2xl w-full py-5 px-6 gap-5">
                  <div>
                    <span class="md:text-lg sm:text-base font-medium text-[#F7FFF7]">{{ "consumption_summary" |
                      translate }}
                    </span>
                  </div>
                  <div class="flex flex-grow w-full justify-center items-center h-fit">
                    <div
                      class="flex flex-row w-fit h-fit lg:mt-2 lg:mb-4 items-stretch justify-between sm:mt-2 md:mt-0 flex-container sm:mb-6">
                      <div class="flex sm:flex-col md:flex-row lg:flex-col justify-between items-stretch h-fit">
                        <div>
                          <span
                            class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                            {{ "Today's Consumption" | translate }}
                          </span>
                        </div>
                        <div class="sm:mt-6 md:mt-0 lg:mt-6 md:ml-4 lg:ml-0">
                          <span
                            class="font-roboto font-medium text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                            {{ statData.todayConsumption || "NA" }}
                          </span>
                        </div>
                      </div>
                      <div class="bg-[#AEAEAE] w-0.5 items-stretch line sm:mx-10 xxl:mx-15"></div>

                      <div class="flex sm:flex-col md:flex-row lg:flex-col w-fit justify-between items-stretch h-fit">
                        <div>
                          <span
                            class="font-roboto text-base ml-0 font-normal tracking-[2%] leading-5 text-left text-[#AEAEAE]">
                            {{ "Accumulated Consumption" | translate }}
                          </span>
                        </div>
                        <div class="sm:mt-6 md:mt-0 lg:mt-6 md:ml-4 lg:ml-0">
                          <span
                            class="font-roboto font-medium text-xl h-[1.4934rem] leading-[100%] tracking-[2%] text-left text-[#EFEDEF]">
                            {{ statData.lifetimeConsumption || "NA" }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>

        </div>
      </div>
    </ng-template>}

    @else if(showNoDataScreen ){
    <div class="h-full w-full items-center justify-center flex inset-0 overflow-hidden">
      <div class="flex flex-col w-full max-w-lg justify-center items-center bg-btTh rounded-2xl p-8 gap-y-9 text-white">
        <span class="label-xl text-center m-1 leading-8">Welcome to {{ plantSelected }} Plant</span>
        <img src="../../../../../assets/images/no-stats.png" class="max-w-72 sm:w-40 md:w-52 lg:w-64" alt="icon" />
        <span class="label-lg max-w-80 text-center leading-7">
          {{"noStatsMessage"|translate}}
        </span>
        <div
          class="flex flex-row justify-center items-center rounded-xl bg-dark-accent-secondary px-4 py-2.5 text-white mt-1 cursor-pointer"
          (appClickableDirective)="navigateToPlantDetail()">
          <span class="text-xs p-0">{{
            "plant_info" | translate
            }}</span>
          <app-chevron-right-icon class="ml-2 text-xs" />
        </div>
      </div>
    </div>
    }
  </div>
  <!-- New code end-->
</div>